"use client";

import { c as _c } from "react/compiler-runtime";
import { useSyncExternalStore } from "react";
import { getDictationTarget, subscribeToDictationTarget } from "@/lib/dictation/target-registry";
import { Mic, Lightbulb } from "lucide-react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { useWritingTools } from "./writing-tools-context";
const voiceTools = [{
  id: "dictation",
  label: "Dictation",
  description: "turn your speech into text",
  Icon: Mic
}, {
  id: "brainstorming",
  label: "Brainstorming",
  description: "speak freely and organize your ideas",
  Icon: Lightbulb
}] as const;
export function AssistantVoiceTools(t0) {
  const $ = _c(9);
  const {
    focusInput,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const tools = useWritingTools();
  let t2;
  if ($[0] !== tools?.targetId) {
    t2 = () => getDictationTarget(tools?.targetId ?? null);
    $[0] = tools?.targetId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const target = useSyncExternalStore(subscribeToDictationTarget, t2, _temp);
  if (!tools) {
    return null;
  }
  let t3;
  if ($[2] !== disabled || $[3] !== focusInput || $[4] !== target?.surface || $[5] !== tools) {
    t3 = voiceTools.map(t4 => {
      const {
        id,
        label,
        description,
        Icon
      } = t4;
      const active = tools.activeTool === id && target?.surface === "assistant";
      const action = active ? `Turn off ${label}` : label;
      return <HoverCard key={id} openDelay={100} closeDelay={200}><HoverCardTrigger asChild={true}><button type="button" aria-label={action} aria-pressed={active} disabled={disabled} className="inline-flex size-8 items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-foreground aria-pressed:bg-accent aria-pressed:text-primary" onClick={() => {
            const targetId = focusInput();
            if (!targetId) {
              return;
            }
            tools.setActiveTool(active && tools.targetId === targetId ? null : id, targetId);
          }}><Icon className="size-4" aria-hidden={true} /></button></HoverCardTrigger><HoverCardContent role="tooltip" className="w-auto max-w-72 px-3 py-2 text-sm" side="top">{active ? action : `${label}: ${description}`}</HoverCardContent></HoverCard>;
    });
    $[2] = disabled;
    $[3] = focusInput;
    $[4] = target?.surface;
    $[5] = tools;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <>{t3}</>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp() {
  return null;
}